import type { QueryClient } from "@tanstack/react-query";
import { useAuthStore } from "../store/authStore";
import { clearFileCache } from "../api/files";
import { bookPdfCache } from "./bookPdfCache";

/**
 * Every logout path ends in `authStore.clearAuth()` (Settings via logout(), FirstLoginPage, a refused token
 * refresh in authRefresh), so watch the
 * signed-in user there: when it goes away, or another account replaces it, drop the whole query cache so the
 * next account in this tab never sees the previous one's feeds, likes or conversations. The file-stc details
 * cache (memory + IndexedDB `whoisit-files`) and the cached book PDFs (Cache Storage `book-pdf-v2`, the old plain `book-pdf-v1` too, and their key) go with it;
 * this is the one place that clears the book cache. Returns the unsubscribe.
 */
export function clearQueryCacheOnUserChange(qc: QueryClient): () => void {
  return useAuthStore.subscribe((state, prev) => {
    if (prev.userId != null && state.userId !== prev.userId) {
      qc.clear();
      void clearFileCache();
      void bookPdfCache.clear();
    }
  });
}
